<!-- En-tête partagé des assistants : « Nouvelle zone », étape 1 ou 2 sur 2, croix.
     Pas de retour ici : à l'étape 2 la zone est déjà créée (revenir à l'étape 1 en
     créerait une autre) ; dans « nouvelle planche », le seul retour est celui de
     l'en-tête du formulaire (« Retour aux planches »). -->
<vw-wizard-header title="garden.zone-wizard.title" [current]="step" [total]="2" (close)="close()"></vw-wizard-header>

@if (step === 1) {
    <!-- Étape 1 : la zone (réutilise vw-user-adress-location-form, sans son propre retour,
         son titre ni son encart : l'assistant les porte). Pas de marge du bas : la barre
         « Continuer » du formulaire colle au bas de l'écran et porte la zone sûre ; une marge
         la ferait remonter au-dessus d'une bande vide en fin de défilement. -->
    <div class="flex flex-col gap-5 px-4 pt-4">
        <div class="flex items-start gap-2 rounded-card bg-vw-surface-tint p-3 text-body-s text-vw-primary-ink">
            <vw-location-home-icon class="mt-0.5 block h-5 w-5 shrink-0 [&>svg]:h-full [&>svg]:w-full" aria-hidden="true" />
            <p>{{ 'garden.zone-wizard.zone-intro' | translate }}</p>
        </div>
        <vw-user-adress-location-form [location]="null" embedded (closeLocationForm)="onZoneCreated($event)"></vw-user-adress-location-form>
    </div>
} @else {
    <div class="flex flex-col gap-5 p-4 pb-[calc(2rem+env(safe-area-inset-bottom))]">
        @if (!showAddBedSheet) {
            <!-- Étape 2 : les planches. Sans planche : « Ajouter une planche » et « plus tard » ;
                 dès qu'une planche existe, « Terminer » devient le bouton principal. -->
            <div class="flex flex-col gap-4">
                <h2 class="text-title-m text-vw-ink">
                    {{ 'garden.zone-wizard.created-title' | translate: { name: $safeNavigationMigration(createdLocation?.name) } }}
                </h2>
                <div class="flex items-start gap-2 rounded-card bg-vw-surface-tint p-3 text-body-s text-vw-primary-ink">
                    <vw-bed-cells-icon class="mt-0.5 block h-5 w-5 shrink-0" aria-hidden="true" />
                    <p>{{ 'garden.zone-wizard.beds-intro' | translate }}</p>
                </div>

                @if (addedBeds.length) {
                    <ul class="flex flex-col divide-y divide-vw-line rounded-card border border-vw-line bg-vw-surface" data-test="wizard-beds">
                        @for (bed of addedBeds; track $index) {
                            <li class="flex min-h-14 items-center gap-3 py-1 pl-3 pr-1">
                                <span class="flex h-9 w-9 shrink-0 items-center justify-center rounded-field bg-vw-surface-tint text-vw-primary">
                                    @if (bed.type === 'POT') {
                                        <vw-pot-icon class="block h-5 w-5" />
                                    } @else {
                                        <vw-bed-cells-icon class="block h-5 w-5" />
                                    }
                                </span>
                                <div class="min-w-0 flex-1">
                                    <p class="truncate text-body font-semibold text-vw-ink">{{ bed.name }}</p>
                                    <p class="text-body-s text-vw-muted">
                                        @if (bed.type === 'POT') {
                                            {{ bed.capacity }} {{ 'garden.zone-wizard.pot-capacity' | translate }}
                                        } @else {
                                            {{ bed.rows }} × {{ bed.columns }}
                                        }
                                    </p>
                                </div>
                                <button type="button" (click)="removeBed($index)" [disabled]="deletingBedIndex !== null" data-test="wizard-delete-bed"
                                    class="flex h-target w-target shrink-0 items-center justify-center rounded-pill text-vw-danger active:bg-vw-surface-sunk disabled:opacity-40"
                                    [attr.aria-label]="'garden.zone-wizard.delete-bed' | translate" [attr.aria-busy]="deletingBedIndex === $index || null">
                                    @if (deletingBedIndex === $index) {
                                        <span class="block h-5 w-5 animate-spin rounded-pill border-2 border-vw-line border-t-vw-danger" aria-hidden="true"></span>
                                    } @else {
                                        <vw-delete-icon class="block h-5 w-5 [&>svg]:h-full [&>svg]:w-full" />
                                    }
                                </button>
                            </li>
                        }
                    </ul>
                }
                @if (removeFailed) {
                    <p role="alert" class="text-body-s text-vw-danger" data-test="wizard-delete-error">{{ 'garden.zone-wizard.delete-error' | translate }}</p>
                }

                <!-- Même bouton pointillé que « Ajouter des graines » dans Mes graines. -->
                <button type="button" (click)="openAddBed()" data-test="wizard-add-bed"
                    class="flex min-h-btn w-full items-center justify-center gap-2 rounded-2xl border-2 border-dashed border-vw-line-strong text-body font-semibold text-vw-primary active:bg-vw-surface-sunk">
                    <vw-plus-icon class="block h-5 w-5 [&>svg]:h-full [&>svg]:w-full" aria-hidden="true" />
                    {{ 'garden.zone-wizard.add-bed' | translate }}
                </button>

                @if (addedBeds.length) {
                    <vw-button data-test="wizard-finish" look="primary" customClass="w-full" label="garden.zone-wizard.finish" (onClick)="finish()"></vw-button>
                } @else {
                    <vw-button data-test="wizard-later" look="quiet" customClass="w-full" label="garden.zone-wizard.later" (onClick)="finish()"></vw-button>
                }
            </div>
        } @else {
            <!-- Sous-feuille : ajouter une planche (réutilise vw-garden-bed-create inline) -->
            <!-- Un seul retour : celui de l'en-tête du formulaire, qui ramène à la liste des planches. -->
            <vw-garden-bed-create [locationUid]="createdLocation.uid" [autoNavigate]="false"
                [backLabel]="'garden.zone-wizard.back-to-beds' | translate"
                (bedCreated)="onBedCreated($event)" (cancelled)="closeAddBed()"></vw-garden-bed-create>
        }
    </div>
}
